
import { HiOutlinePhotograph } from "react-icons/hi"
import useQueryDowload from "../../customHooks/useQueryDowloand"
import { FaRegFilePdf } from "react-icons/fa"

interface Props{
    url:string
    url_bw :string
    id_employee:string
    id_campaign:string
    title:string
    name:string
    name_bw:string
    image:string
}
const Flyer = ({ url, url_bw, id_employee, id_campaign, title, name, name_bw, image}:Props)=>{
   const {isLoading,onGenerate}=useQueryDowload({name:`${name}.pdf`})
   const {isLoading:isLoadingBw,onGenerate:onGenerateBw}=useQueryDowload({name:`${name_bw}.pdf`})

   const onDownloadOne =() =>{
       onGenerate({
        url,
        params:{
            id_employee,
            id_campaign
        }
       })
   }

    const onDownloadTwo =() =>{
        onGenerateBw({
         url:url_bw,
         params:{
             id_employee,
             id_campaign
         }
        })
    }

   return(
    <div className="c-flyers__container">
        <div className="c-flyers__header">
        <span className="c-flyers__title">{title}</span>
        </div>
        <div className="c-flyers__content" >
            <img src={image} className={`c-flyers__img-qr`} alt="flyer-campaign"/>
        </div>
        <button className={`c-flyers__button-download ${isLoading && `c-flyers__button-download--disabled`}`} onClick={onDownloadOne}>
        {
            isLoading ?
            <>
            Download...<div className="spiner"></div>
            </>
            :
            <>
                Download color  <FaRegFilePdf />
            </>
        }
        </button>
        <button className={`c-flyers__button-download ${isLoadingBw && `c-flyers__button-download--disabled`}`} onClick={onDownloadTwo}>
        {
            isLoadingBw ?
            <>
                Download...<div className="spiner"></div>
            </>
            :
            <>
                Download Black & White Flyer
                <FaRegFilePdf />
            </>
        }
        </button>
    </div>
    )
}
export default Flyer